import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";

// Warm up the connection to the CDN that serves images and the app bundle
// before React even mounts — shaves the DNS/TLS handshake off the critical
// path for the LCP image and other early network requests.
if (typeof document !== "undefined") {
  const preconnect = document.createElement("link");
  preconnect.rel = "preconnect";
  preconnect.href = "https://cdn.magicpatterns.com";
  document.head.appendChild(preconnect);
}
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-299" data-mp="2k20a2rp2gr7p" />);
}